import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Card,
  CardContent,
  Typography,
  Box,
  LinearProgress,
  Grid,
  IconButton,
  Container
} from "@mui/material";
import { BsEyeFill, BsPencilSquare, BsTrashFill, BsX } from "react-icons/bs";
import Swal from "sweetalert2";
import usericon from './user.png'
import './main.css'

export default function MoreInfo({ defData, hide = [], onClose = () => { } }) {
  const navigate = useNavigate()
  const location = useLocation()
  const { data, title, prevNav } = location.state || {};

  return (
    <Container maxWidth={false} fluid sx={{ my: 2 }}>
      <Grid container>
        <Grid size={{ sm: 12, md: 6 }} sx={{ position: 'relative' }}>
          <Box
            className="card-bg shadow"
            sx={{
              p: 4,
            }}

          >
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
              <Box sx={{ fontWeight: 'bold', fontSize: 14, mb: 3, textAlign: 'center' }}>Details of {title}</Box>
              <Box className="round danger">
                <BsX onClick={() => {
                  onClose()
                  if (typeof prevNav === 'object') {
                    navigate(prevNav?.url, prevNav?.state)
                  } else { navigate(prevNav) }
                }}></BsX>
              </Box>
            </Box>

            {Object.keys(data || {}).map((key) => {
              if (hide.includes(key)) return null
              let value = data[key];
              if (typeof value == 'object') {
                 if (Array.isArray(value)) {
                     value = value.join(', ');
                 } else {
                     return null;
                 }
              }
              return <Box display={'flex'} sx={{ gap: 3, my: 2 }} justifyContent={'space-between'}>
                <Box sx={{ textTransform: 'capitalize' }}>{key?.replaceAll("_", " ")}</Box>
                <Box sx={{ fontWeight: 500 }}>{value}</Box>
              </Box>
            })}
          </Box>
        </Grid>
      </Grid>
    </Container>
  );
}
